import Checkbox from './Checkbox';

export default Checkbox;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-checkbox/src/index.js
// module id = 790
// module chunks = 0